import React from "react";
import "../assets/css/Footer.scss";

const Footer = () => {
  return (
    <div className="footer">
      <div className="footer_container">
        <h4>DELTAfoods</h4>
        <p>© 2022. DELTAfoods - 04219520154</p>
      </div>
    </div>
  );
};

export default Footer;
